var alphabeticRegExp = /^[a-z]*$/i;
export default (function (value) {
  var error = alphabeticRegExp.test(value) ? '' : 'Alphabetic string is invalid';
  return error;
});